import Player from './player';

class Human extends Player {
  async getNextShot(targetGameboard) {}
}

export default Human;
